type TeamMembership = {
  _id: string;
  userIds: string[];
};

export const getDefaultOrderTeamFilterId = (
  userId: string | undefined,
  teams: TeamMembership[],
  urlTeamOperationsId?: string | null,
): string => {
  if (urlTeamOperationsId) {
    return urlTeamOperationsId;
  }

  if (!userId) {
    return "";
  }

  const memberTeam = teams.find((team) => team.userIds.includes(userId));
  return memberTeam?._id ?? "";
};
